import React, { Component } from "react";

import ProfileComponent from "../../components/Profile";

import Header from "../Header";

class Profile extends Component {
  render() {
    return (
      <div>
        <Header />
        <ProfileComponent />
      </div>
    );
  }
}

export default Profile;
